<script>
import freeeForm from "@/driver/pages/masters/tenants/providers/_freee.vue";
import {mapActions, mapGetters, mapState} from "vuex";

export default {
  name: "ProviderFreeCompany",
  components: {
  },
  mixins: [],
  props: {
    provider: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      breadcrumbs: [
        { text: '契約情報', disabled: false, to: '/driver/masters/tenants', exact: true },
        { text: '外部サービス連携', disabled: true, to: '' },
      ],
      form: {
        id: null,
        linkage_id: null,
        linkage_name: null,
        linked: false
      },
      companies: [
        { value: 123, text: "xxxxxx株式会社"},
        { value: 456, text: "yyyyyy株式会社"},
      ],
    }
  },
  computed: {
    ...mapState("DriverProviderSetting", {
      state: "state",
    }),
    ...mapGetters("DriverProviderSetting", [
      "isConfigured",
    ])
  },
  watch: {
  },
  created() {
    this.loadCompanies();
  },
  methods: {
    ...mapActions("DriverProviderFreeeCompany", {
      fetchCompanies: "index",
      updateCompany: "update",
    }),
    registerButtonClickEvent () {
      this.$refs.companyValidator.validate().then((result) => {
        if (result) {
          const company = this.companies.find( (v) => v.value === this.form.linkage_id)
          this.form.linkage_name = company.text;
          this.updateCompany({ params: this.form }).then(() => {
            this.$router.replace({ name: 'DriverMasterTenant' })
          })
        }
      })
    },
    reloadCompaniesButtonClickEvent () {
      this.loadCompanies();
    },
    loadCompanies () {
      this.companies = null;
      this.fetchCompanies().then((content) => {
        this.companies = content.companies;
      })
    }


  },

}
</script>

<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <validation-observer ref="companyValidator">
      <v-card>
        <v-card-title>
          freee請求連携
        </v-card-title>
        <v-card-subtitle>
          連携されたfreeeのアカウントには複数の事業所が紐付いています。<br />
          連携する事業所を選択してください。
        </v-card-subtitle>
        <v-divider />
        <v-card-text>
          <v-row>
            <v-col cols="12" md="5">
              <validation-provider
                v-slot="{ errors }"
                rules="required"
                name="事業所"
                class="requiredMark"
              >
                <v-select
                  v-model="form.linkage_id"
                  :error-messages="errors"
                  :items="companies"
                  dense
                  label="事業所"
                  outlined
                  hide-details="auto"
                  persistent-placeholder
                >
                  <template v-slot:append-outer>
                    <v-btn
                      small
                      @click="reloadCompaniesButtonClickEvent"
                    >
                      再読み込み
                    </v-btn>
                  </template>
                </v-select>
              </validation-provider>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            @click="registerButtonClickEvent"
          >
            登録
          </v-btn>
        </v-card-actions>
      </v-card>
    </validation-observer>
  </v-container>
</template>

<style scoped lang="scss">

</style>
